export const intialDataToLocalStorage = {
    "kaba_info": {
        "login": {
            "signin": true,
            "verification": false,
            "signup": false,
            "oups": false
        },
        "one_time_password": {
            "one_time_password_id": "",
            "one_time_passoword_type": "",
            "one_time_password": "",
            "one_time_password_quota_day": 10
        },
        "help":false,
        "ticket":{
            "ticket": false,
            "data":[],
        },
        "neguediourou": "",
        "phone": "",
        "kabakoo.africa.token": "",
        "source": "https://app.kabakoo.africa/",
        "time": '2023-09-05T17:57:30.973Z',
        "device_id": ""
    }
}